import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class IncallService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.incallUrl = `${services.ask_pratiche.url}/incall`
    this.praticheUrl = `${services.ask_pratiche.url}/`
    this.baseUrl = `${services.ask_api.url}/management`
    this.callUrl = `${services.ask_call_api.url}`
    this.filemanager = new FileManager()
  }

  async searchContatti(searchString, limit = 20) {
    let items = {}
    const url = `${this.incallUrl}/search/contatti`

    try {
      let res = await this.http.get(url, {
        params: {
          search: searchString,
          limit: limit
        }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async getDettaglioContatto(contattoId) {
    let item = {}
    const url = `${this.incallUrl}/contatto/${contattoId}`

    try {
      let res = await this.http.get(url)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      item,
    }
  }

  async getTicketsByContatto(contattoId) {
    let items = {}
    const url = `${this.incallUrl}/contatto/${contattoId}/tickets`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }
  
  async getTypesAreaTicket(){
    let items = {}
    const url = `${this.incallUrl}/types/area`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesEntity() {
    let items = {}
    const url = `${this.incallUrl}/types/entity`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async getTicketEntity(string, type, { limit = 10, offset = 0, id_field = 'id', min_length = 2, filters = {} } = {}) {
    const url = `${this.incallUrl}/ticket/entity`
    try {
      const payload = { string, type, limit, offset, id_field, min_length, filters }
      const res = await this.http.post(url, payload)
      const data = res.data || {}
      return {
        items: Array.isArray(data.data) ? data.data : [],
        total: Number(data.total || 0),
        has_more: Boolean(data.has_more),
        limit: Number(data.limit || limit),
        offset: Number(data.offset || offset),
        min_length: Number(data.min_length || min_length)
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getStatus() {
    let items = {}
    const url = `${this.incallUrl}/status`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      items,
    }
  }

  async getMotivationTicket() {
    let items = []
    const url = `${this.incallUrl}/motivation-ticket`

    try {
      let res = await this.http.get(url)
      const data = res.data
      if (data?.success && Array.isArray(data?.data)) {
        items = data.data
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return {
      items,
    }
  }

  async getTickets() {
    let items = {}
    const url = `${this.incallUrl}/tickets`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async getTicketDetails(ticket) {
    let item = {}
    const idTicket = ticket?.id_ticket ?? ticket?.id
    const url = `${services.ask_pratiche.url}/ticket/info/ticket/${idTicket}`

    if (!idTicket) {
      return { item }
    }

    try {
      const res = await this.http.get(url)
      const data = res?.data
      if (data?.success && data?.data) {
        item = data.data
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      item,
    }
  }

  async downloadFattureZip(numeriFattura = []){
    const url = `${this.baseUrl}/clienti/fatture/zip`
    try {
      const payload = {
        filters: {
          'fattura_vendita.numeri': numeriFattura
        }
      }
      const res = await this.http.post(url, payload, { responseType: 'blob' })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  
  async getTicketRecipients(string, type, options = {}, requestOptions = {}) {
    let items = []
    const url = `${this.incallUrl}/ticket/recipients`
    const payload = { string, type }

    if (options.id) {
      payload.id = options.id
    }
    if (options.rappresentante_id) {
      payload.rappresentante_id = options.rappresentante_id
    }

    try {
      const res = await this.http.post(url, payload)
      items = Array.isArray(res.data) ? res.data : []
    } catch (err) {
      if (!requestOptions.silent) {
        this.eventBus.emit('data-load-error', { message: err, url })
      }
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items }
  }



  async createTicket(ticket){
    let success = false
    const url = `${this.incallUrl}/ticket/create`
    
    try {
      let res = await this.http.post(url, {  
        ticket   
      })
      success = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          success,
        }
    }

  }

  async previewTicketNotificationEmail(payload = {}) {
    const url = `${this.incallUrl}/ticket/preview-notification-email`
    try {
      const res = await this.http.post(url, payload)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async sendTicketNotificationEmail(payload = {}) {
    const url = `${this.incallUrl}/ticket/send-notification-email`
    try {
      const res = await this.http.post(url, payload)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async sendMessage(ticketId, messageContent, files = [], options = {}){
    let data = false
    const url = `${this.incallUrl}/message/create`

    let fd = new FormData();
    for (let i = 0 ; i < files.length ; i++) {
      fd.append('attachments[]', files[i]); 
    }
    fd.append('ticketId', ticketId)
    fd.append('messageContent', messageContent)

    const callTransfer = options.callTransfer ?? null
    if (callTransfer && callTransfer.success !== null && callTransfer.success !== undefined && callTransfer.success !== '') {
      fd.append('call_transfer[success]', callTransfer.success ? '1' : '0')
      if (callTransfer.id_ticket_area) {
        fd.append('call_transfer[id_ticket_area]', callTransfer.id_ticket_area)
      }
    }
    
    try {
      let res = await this.http.post(url, fd)
      data = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          data,
        }
    }

  }

  async setMessageAsRead(messages){
    let data = false
    const url = `${this.incallUrl}/messages/mark/read`
    
    try {
      let res = await this.http.post(url, {  
        messages  
      })
      data = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          data,
        }
    }

  }
  async changeStatus(ticketId, newStatus){
    let success = false
    const url = `${this.incallUrl}/change/status`
    
    try {
      let res = await this.http.post(url, {  
        ticketId,
        newStatus  
      })
      success = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          success,
        }
    }

  }
  async assignTicket(ticketId, assignObj){
    let success = false
    const url = `${this.incallUrl}/assign`
    
    try {
      let res = await this.http.post(url, {  
        ticketId,
        assignObj
      })
      success = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          success,
        }
    }

  }

  async getNewTicketsNumbers(){
    let items = {}
    const url = `${this.incallUrl}/tickets/new/numbers`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async downloadAttachment(attachment){

    const url = `${this.incallUrl}/download/attachment`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: attachment,
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }
  async openAttachment(attachment){

    const url = `${this.incallUrl}/download/attachment`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: attachment,
            responseType: 'blob',
          })

        this.filemanager.open(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async sendEstrattoContoPdf(idCliente, tipo = 'cliente', idRappresentante = null, daInviare = 1, inviaAlRappresentante = false, annoPartenza = null, completo = 0, codPod = null, codPdr = null, escludiCrediti = 0, statoFornitura = 'all_state') {
    let result = {}
    const url = `${this.baseUrl}/estratto-conto/pdf`
    
    const requestData = {
      tipo: tipo,
      da_inviare: daInviare,
      completo: completo,
      stato_fornitura: statoFornitura,
    }
    
    if (tipo === 'rappresentante') {
      requestData.id_rappresentante = idRappresentante
    } else {
      requestData.id_cliente = idCliente
      if (inviaAlRappresentante && idRappresentante) {
        requestData.invia_al_rappresentante = true
        requestData.id_rappresentante = idRappresentante
      }
    }
    
    if (annoPartenza) {
      requestData.anno_partenza = annoPartenza
    }
    if (codPod) {
      requestData.cod_pod = codPod
    }
    if (codPdr) {
      requestData.cod_pdr = codPdr
    }
    if (escludiCrediti) {
      requestData.escludi_crediti = escludiCrediti
    }
    
    try {
      if (daInviare === 0) {
        const response = await this.http.post(url, requestData, {
          responseType: 'blob'
        })
        return response.data
      } else {
        let res = await this.http.post(url, requestData)
        result = res.data
        return result
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadBollettiniPostaliZip(numeriFattura = [], isSaldo = 0, composizione = 'singoli'){
    const url = `${this.baseUrl}/clienti/fatture/bollettini-postali/zip`
    try {
      const payload = {
        filters: {
          'fattura_vendita.numeri': numeriFattura
        },
        isSaldo,
        composizione
      }
      const res = await this.http.post(url, payload, { responseType: 'blob' })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
  

  async sendBollettinoPostalePdf(idCliente, tipo = 'cliente', idRappresentante = null, fattureSelezionate = null, isSaldo = true, composizione = 'singoli') {
    let result = {}
    const url = `${this.baseUrl}/clienti/send/fatture/bollettini-postali/pdf`
    
    const requestData = {
      tipo: tipo,
      is_saldo: !!isSaldo,
      composizione,
    }
    
    if (tipo === 'rappresentante') {
      requestData.id_rappresentante = idRappresentante
    } else {
      requestData.id_cliente = idCliente
    }

    
    if (fattureSelezionate && fattureSelezionate.length > 0) {
      requestData.fatture_selezionate = fattureSelezionate
    }
    
    try {
      let res = await this.http.post(url, requestData)
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return result
  }

  async getTotaliEstrattiConto(idCliente, tipo = 'cliente', idRappresentante = null, annoPartenza = null, completo = 0, codPod = null, codPdr = null, escludiCrediti = 0, statoFornitura = 'all_state') {
    let result = {}
    const url = `${this.baseUrl}/estratto-conto/totali`
    
    const requestData = {
      tipo: tipo,
      completo: completo,
      stato_fornitura: statoFornitura,
    }
    
    if (tipo === 'rappresentante') {
      requestData.id_rappresentante = idRappresentante
    } else {
      requestData.id_cliente = idCliente
    }
    
    if (annoPartenza) {
      requestData.anno_partenza = annoPartenza
    }
    if (codPod) {
      requestData.cod_pod = codPod
    }
    if (codPdr) {
      requestData.cod_pdr = codPdr
    }
    if (escludiCrediti) {
      requestData.escludi_crediti = escludiCrediti
    }
    
    try {
      let res = await this.http.post(url, requestData)
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return result
  }

  async searchByCodiceFiscale(codiceFiscale, tipo = 'cliente') {
    let items = {}
    const endpoint = tipo === 'cliente' 
      ? '/search/codice-fiscale-cliente'
      : '/search/codice-fiscale-rappresentante'
    const url = `${this.incallUrl}${endpoint}`

    try {
      let res = await this.http.get(url, {
        params: { search: codiceFiscale, limit: 20 }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async searchByCodiceCliente(codiceCliente) {
    let items = {}
    const endpoint = '/search/codice-cliente'
    const url = `${this.incallUrl}${endpoint}`

    try {
      let res = await this.http.get(url, {
        params: { search: codiceCliente, limit: 20 }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
    
  }

  async searchByNumeroFattura(numeroFattura) {
    let items = {}
    const url = `${this.incallUrl}/search/numero-fattura`

    try {
      let res = await this.http.get(url, {
        params: { search: numeroFattura, limit: 20 }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      items,
    }
  }

  async searchByNomeRagioneSociale(nome, tipo = 'cliente') {
    let items = {}
    const endpoint = tipo === 'cliente' 
      ? '/search/nome-ragione-sociale-cliente'
      : '/search/nome-ragione-sociale-rappresentante'
    const url = `${this.incallUrl}${endpoint}`

    try {
      let res = await this.http.get(url, {
        params: { search: nome, limit: 20 }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async searchByPDP(pdp) {
    let items = {}
    const url = `${this.incallUrl}/search/pdp`

    try {
      let res = await this.http.get(url, {
        params: { search: pdp, limit: 20 }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async getContactToCall(days = 3, page = 1, limit = 20) {
    let items = {}
    const url = `${this.praticheUrl}get-contact-to-call`

    try {
      let res = await this.http.get(url, {
        params: { days, page, limit }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      items,
    }
  }

  async getContattoRappresentante(contattoId) {
    let item = {}
    const url = `${this.incallUrl}/contatto-rappresentante/${contattoId}`

    try {
      let res = await this.http.get(url)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      item,
    }
  }

  async getUserTickets(userId, entityType) {
    let items = {}
    const url = `${this.incallUrl}/user/tickets`

    try {
      let res = await this.http.get(url, {
        params: { user_id: userId, user_type: entityType }
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return {
      items,
    }
  }

  async createTicketBase(params) {
    let result = {}
    const url = `${this.praticheUrl}ticket/ticket/create/base`
    
    try {
      let res = await this.http.get(url, { params })
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return result
  }

  async createRiattivazione(items) {
    let result = {}
    const url = `${this.praticheUrl}operation/preview/multi/sospensioni-riattivazioni`
    
    const requestData = {
      items: items,
      typeFornitura: '', 
      typePratica: 'riattivazioni'
    }
    
    try {
      let res = await this.http.post(url, requestData)
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
    
    return result
  }

  async getAppuntamentiRiattivazioni(payload) {
    const url = `${this.incallUrl}/appuntamenti-riattivazioni`

    try {
      const res = await this.http.post(url, payload)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getPraticheFiles(options = {}) {
    const url = `${this.incallUrl}/pratiche-files`
    const {
      idCliente = 0,
      idRappresentante = 0,
      idAssignedUser = 0,
      assignedUserType = '',
    } = options

    try {
      const res = await this.http.get(url, {
        params: {
          id_cliente: idCliente || undefined,
          id_rappresentante: idRappresentante || undefined,
          id_assigned_user: idAssignedUser || undefined,
          assigned_user_type: assignedUserType || undefined,
        },
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadPraticaFile(filename, options = {}) {
    const url = `${this.incallUrl}/pratiche-files/download`
    const {
      sendEmail = false,
      email = '',
      subject = '',
      body = '',
      clienteNome = '',
      praticaName = '',
      idCliente = 0,
      idRappresentante = 0,
      idAssignedUser = 0,
      assignedUserType = '',
      preview = false,
      fields = null,
      fill = false,
    } = options

    try {
      const payload = {
        filename,
        send_email: !!sendEmail,
        fill: !!fill || !!(fields && Object.keys(fields).length),
      }

      if (fields && typeof fields === 'object') {
        payload.fields = fields
        // fallback esplicito per alcuni proxy/client
        payload.fields_json = JSON.stringify(fields)
      }

      if (sendEmail) {
        Object.assign(payload, {
          email,
          subject,
          body,
          cliente_nome: clienteNome,
          pratica_name: praticaName,
          id_cliente: idCliente || undefined,
          id_rappresentante: idRappresentante || undefined,
          id_assigned_user: idAssignedUser || undefined,
          assigned_user_type: assignedUserType || undefined,
        })
        const res = await this.http.post(url, payload)
        return res.data
      }

      const res = await this.http.post(url, payload, { responseType: 'blob' })

      if (preview) {
        return res
      }

      this.filemanager.download(res)
      return res
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async sendPraticaOtpSign(payload = {}) {
    const url = `${this.incallUrl}/pratiche-files/send-otp`

    try {
      const normalized = {
        filename: payload.filename,
        pratica_name: payload.pratica_name || payload.praticaName || '',
        pratica_code: payload.pratica_code || payload.praticaCode || '',
        email: payload.email,
        nominativo: payload.nominativo,
        contatto: payload.contatto,
        cliente_nome: payload.cliente_nome || payload.clienteNome || '',
        fill: payload.fill,
        fields: payload.fields,
        id_cliente: payload.id_cliente ?? payload.idCliente ?? undefined,
        id_rappresentante: payload.id_rappresentante ?? payload.idRappresentante ?? undefined,
        id_assigned_user: payload.id_assigned_user ?? payload.idAssignedUser ?? undefined,
        assigned_user_type: payload.assigned_user_type || payload.assignedUserType || undefined,
      }

      if (normalized.fields && typeof normalized.fields === 'object') {
        normalized.fields_json = JSON.stringify(normalized.fields)
      }

      const res = await this.http.post(url, normalized)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadSignedPraticaFile(codRichiestaFirma) {
    const url = `${this.incallUrl}/pratiche-files/download-signed`

    try {
      const res = await this.http.post(url, {
        cod_richiesta_firma: codRichiestaFirma,
      }, { responseType: 'blob' })
      this.filemanager.download(res)
      return res
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async previewPraticaFile(filename, fields = null) {
    const fieldsPayload = fields && typeof fields === 'object' ? fields : {}
    const response = await this.downloadPraticaFile(filename, {
      preview: true,
      fill: true,
      fields: fieldsPayload,
    })
    const blob = response?.data instanceof Blob
      ? response.data
      : new Blob([response?.data], { type: 'application/pdf' })

    // Se il backend ha risposto con JSON di errore in un blob
    const contentType = response?.headers?.['content-type'] || blob.type || ''
    if (contentType.includes('application/json') || contentType.includes('text/')) {
      const message = await blob.text()
      let parsed = null
      try {
        parsed = JSON.parse(message)
      } catch (e) {
        parsed = null
      }
      throw new Error(parsed?.message || message || 'Anteprima PDF non disponibile')
    }

    if (blob.size < 100) {
      const message = await blob.text()
      throw new Error(message || 'Anteprima PDF non disponibile')
    }

    return URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
  }

  async fillPraticaFile(filename, fields = {}) {
    return this.previewPraticaFile(filename, fields)
  }

  async downloadQuietanzaPdf(objs) {
    const url = `${this.praticheUrl}operation/fatture-vendita/quietanza/download`
    
    try {
      const response = await this.http.post(url, { objs }, {
        responseType: 'blob'
      })
      return response.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async inviaEmailBonaria(numeriFattura, userId) {
    let result = {}
    const url = `${services.ask_pratiche_base.url}/api/mail-sender/proforma-sollecito-privilegiati`

    try {
      let res = await this.http.post(url, {
        numeri_fattura: numeriFattura,
        user_id: userId
      })
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return result
  }

  async resolveVoxloudExtension(askId) {
    const url = `${this.praticheUrl}getInternalVoxloud`
    const res = await this.http.get(url)
    const rows = Array.isArray(res?.data) ? res.data : []
    const match = rows.find((row) => {
      return Number(row?.user_ask_id) === Number(askId) && row?.extension_number != null && String(row.extension_number) !== ''
    })
    return match ? String(match.extension_number) : null
  }

  async makeCall(ask_id = null, number) {
    const url = `${this.callUrl}/call`

    if (!ask_id) {
      this.eventBus.emit('data-load-error', { message: 'ID utente non valido', url })
      throw new Error('ID utente non valido')
    }

    try {
      let normalizedNumber = (number || '').toString().trim()
      if (normalizedNumber && !normalizedNumber.startsWith('+39')) {
        normalizedNumber = `+39${normalizedNumber.replace(/^0+/, '')}`
      }

      const extension = await this.resolveVoxloudExtension(ask_id)
      if (!extension) {
        throw new Error('Nessun interno Voxloud associato a questo utente')
      }

      const res = await this.http.post(url, {
        number: normalizedNumber,
        extension,
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err?.response?.data?.message || err?.message || err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async saveCallNotes(call_id, notes) {
    const url = `${this.callUrl}/chiamate/${call_id}/note`

    if (!call_id || isNaN(Number(call_id)) || String(notes ?? '').trim() === '') {
      this.eventBus.emit('data-load-error', { message: 'Dati della chiamata non validi', url })
      throw new Error('Dati della chiamata non validi')
    }

    try {
      const payload = {
        note: String(notes).trim()
      }

      const res = await this.http.post(url, payload)

      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {
        message: err?.response?.data?.message || err.message || 'Errore durante il salvataggio delle note',
        url
      })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getSmsTemplates() {
    let result = {}
    const url = `${services.ask_pratiche_base.url}/api/sms-template/get`

    try {
      let res = await this.http.get(url)
      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return result
  }

  async sendSms(number, smsBody, recipientType = null) {
    const url = `${services.ask_pratiche_base.url}/api/sms-sender/send-sms`;

    const payload = {
      number,
      sms_body: smsBody,
      recipient_type: recipientType,
    };

    const res = await this.http.post(url, payload);
    return res.data;
  }
}
